export default __webpack_public_path__ + "static/media/800px-MSgt.ef377c50.jpg";